<script>
import EdaButton from "./vButton";
import EdaBubble from "./vClickModal";

export default {
  name: "VCardGeneric",
  components: {
    EdaButton,
    EdaBubble
  },

  props: {
    title: { type: String, default: "" },
    titlePrefix: { type: String, default: "" },
    selected: { type: Boolean, default: false },
    subtitle: {
      type: Array, default: function () {
        return [];
      }
    },
    buttonLabelDefault: { type: String, default: "" }, object: {
      type: Object, default: function () {
        return {};
      }
    },
    onClick: {
      type: Function, default: function () {
        return false;
      }
    },

    type: { type: String, default: "button" },
    price: { type: Number, default: 0 },
    imageUrl: { type: String, default: "" },
    imageMask: { type: Boolean, default: false },
    images: {
      type: Object, default: function () {
        return {};
      }
    }, details: {
      type: Object, default:
          function () {
            return {
              heading: "",
              label: "",
              items: [],
            };
          }
    }
    ,
  },
  data: function () {
    return {
      hover: false,
      buttonLabel: this.buttonLabelDefault ? this.buttonLabelDefault : "",
    };
  },
  computed: {
    toggleLabel() {
      return this.selected ?
        this.$t("genericCard.toggleLabel.added") :
        this.$t("genericCard.toggleLabel.add");
    }
  }

};
</script>

<template>
  <div
    class="eda-card"
    @click="onClick"
    @mouseover="hover=true"
    @mouseleave="hover=false"
  >
    <div
      class="eda-card__image"
      :class="{'eda-card__masked-image': imageMask}"
    >
      <img
        v-if="imageUrl.length"
        class="eda-card__img"
        :src="imageUrl"
        alt=""
      >
    </div>
    <div class="eda-card__heading">
      <div
        v-if="titlePrefix"
        class="eda-card__title-prefix"
      >
        {{ titlePrefix }}
      </div>

      <div
        v-if="title"
        class="eda-card__title"
      >
        {{ title }}
      </div>
    </div>
    <div
      v-if="subtitle.length"
      class="eda-card__subtitle"
    >
      <template v-for="line in subtitle">
        <div
          :key="line.text"
          class="eda-card__subitle-line"
        >
          {{ line.text }}
        </div>
      </template>
    </div>
    <div class="eda-card__spacer" />

    <div
      v-if="price"
      class="eda-card__price"
    >
      {{ price }},-
    </div>

    <template v-if="type == 'button'">
      <div class="eda-card__button">
        <eda-button
          v-if="buttonLabel.length"
          :label="buttonLabel"
        />
      </div>
    </template>

    <template v-if="type == 'toggle'">
      <div class="eda-card__toggle">
        <eda-button
          :unselected="!selected"
          :label="toggleLabel"
        />
      </div>
    </template>

    <template v-if="details.items.length">
      <eda-bubble
        class="eda-card__details"
        :class="{'eda-card__details--show': hover}"
        :heading="details.heading"
        :label="details.label"
        :items="details.items"
      />
    </template>
  </div>
</template>

<style>
    .eda-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: white;
        padding: 1em 2em 1.5em 2em;
        width: 100%;
        cursor: pointer;
        text-align: center;
    }

    .mq-mobile .eda-card,
    .mq-tablet .eda-card,
    .mq-laptop .eda-card {
        padding: 1em 1em 1.5em 1em;
    }

    .eda-card__image {
        min-height: 1px; /* to fix IE flexbox image sizing bug */
        width: 100%
    }

    .eda-card__img {
        width: 100%;
        height: 100%;
    }

    .eda-card__heading {
        text-align: center;
        display: flex;
        padding: 0.25em 0 0.25em 0;
    }

    .mq-mobile .eda-card__heading,
    .mq-tablet .eda-card__heading,
    .mq-laptop .eda-card__heading {
        flex-direction: column
    }

    .eda-card__title-prefix {
        padding-right: 0.5em;
        color: #00B27C;
    }

    .eda-card__price {
        padding: 0.5em 0 0.5em;
        font-size: 0.8em;
        font-weight: 600;
    }

    .eda-card__details {
        position: absolute;
        top: 1em;
        right: 1em;
        opacity: 0;
        transition: all 0.2s ease;
    }

    .eda-card__details--show {
        opacity: 1
    }

    .eda-card__subtitle {
        padding: 0.25em 0;
        font-weight: 300;
        font-size: 0.9em;
        color: #808080;
        width: 100%;
        position: relative;
    }

    .eda-card__subtitle-group {
        width: 100%;
    }

    .eda-card__subtitle-line {
        transition: all 0.1s ease-out;
    }

    .eda-card__subtitle-line--hidden {
        opacity: 0;
        /*  transform: translateY(1 em); */
    }

    .eda-card__spacer {
        flex-grow: 1;
    }

    .eda-card__button {
        padding-top: 0.75em;
    }

    .eda-card__toggle {
        padding-top: 0.75em;
    }

</style>
